import { render, staticRenderFns } from "./ChangeHistory.vue?vue&type=template&id=4ba764f2&"
import script from "./ChangeHistory.vue?vue&type=script&lang=js&"
export * from "./ChangeHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports